var app = {
	header: {
		build: "Build",
		closeButton: "Schließen",
		copyrightLabel: "Copyright",
		helpLabel: "Hilfe",
		legalNoticeLabel: "Impressum",
		logoutButton: "Abmelden",
		menuLabel: "Menü",
		module: "Modul",
		noUserDataLabel: "Keine Daten vorhanden",
		notificationsLabel: "Nachrichten",
		privacyPolicyLabel: "Datenschutz",
		serviceAppLabel: "Service-App",
		settingsLabel: "Einstellungen",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Softwareinformationen",
		userLabel: "Profil",
		userProfileLinkText: "Nutzer Profil",
		version: "Version"
	}
};
var contentLoadingError = "Inhalt konnte nicht geladen werden";
var dashboard = {
	cancel: {
		button: "Abbrechen"
	},
	edit: {
		button: "Bearbeiten"
	},
	reset: {
		button: "Zurücksetzen"
	},
	save: {
		button: "Speichern"
	},
	share: {
		button: "Teilen"
	}
};
var filter = {
	clear: "Filter zurücksetzen",
	clearAll: "Alle Filter zurücksetzen"
};
var locationMap = {
	locationLink: {
		label: "Zum Standort"
	}
};
var machineDiscontinuation = {
	linkText: "Mehr erfahren"
};
var notifications = {
	button: {
		loadMore: "Mehr laden"
	},
	date: {
		lastMonth: "Letzter Monat",
		lastWeek: "Letzte Woche",
		older: "Älter",
		thisMonth: "Dieser Monat",
		thisWeek: "Diese Woche",
		today: "Heute",
		yesterday: "Gestern"
	},
	error: {
		general: "Aktuell können keine Benachrichtigungen angezeigt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
		unauthorized: "Bitte melden Sie sich an, um Benachrichtigungen zu sehen."
	},
	info: {
		activateSettings: "Um Benachrichtigungen zu erhalten, aktivieren Sie diese bitte in den Einstellungen",
		noNotification: "Derzeit liegen keine Benachrichtigungen für Sie vor."
	},
	title: "Benachrichtigungen"
};
var results = {
	counter: {
		label: "Treffer"
	}
};
var scrollToTop = {
	label: "Nach oben scrollen"
};
var slider = {
	nextButton: {
		label: "Nächste Folie"
	},
	paginationBullet: {
		label: "Folie"
	},
	prevButton: {
		label: "Vorherige Folie"
	}
};
var sorting = {
	ascending: "Aufsteigend",
	descending: "Absteigend"
};
var tab = {
	next: "Nach rechts scrollen",
	previous: "Nach links scrollen"
};
var userAccount = {
	address: {
		label: "Adresse"
	},
	email: {
		label: "E-Mail"
	},
	language: {
		label: "Sprache",
		locale: "Gebietsschema",
		select: "Sprache wählen",
		settings: "Spracheinstellungen"
	},
	loggedOut: {
		message: "Sie sind nicht angemeldet"
	},
	login: {
		button: "Anmelden"
	},
	name: {
		label: "Name"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Machinen filtern",
			label: "Maschinen",
			option: {
				all: "Alle Maschinen"
			},
			select: "Machine auswählen"
		},
		period: {
			label: "Zeitraum",
			option: {
				currentMonth: "Dieser Monat",
				currentWeek: "Diese Woche",
				lastMonth: "Voriger Monat",
				lastWeek: "Vorige Woche",
				today: "Heute",
				yesterday: "Gestern"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Meine Widgets"
	},
	noDescriptionAvailable: "Keine Beschreibung verfügbar.",
	widget: {
		SampleMyMachines: {
			title: "Meine Maschinen"
		},
		SampleMyServiceCalls: {
			title: "Servicefälle"
		},
		SampleMyTrackingList: {
			title: "Lieferstatus"
		},
		SampleMyUserAccount: {
			title: "Mein Profil"
		},
		SampleOperationalStatesChart: {
			title: "Betriebszustände"
		},
		SampleWidgetFilter: {
			title: " Filter Einstellungen"
		},
		SampleWorkloadBalanceChart: {
			title: "Auslastung"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	tab: tab,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, tab, userAccount, widget, widgetRegistry };
